// 转换
import Vue from 'vue'
import DecimalConvert from '../../utils/DecimalConvert'
// 将浮点数四舍五入，取小数点后1位
Vue.filter('toDecimal', function(value, position) {
  return DecimalConvert.toDecimal(value, position)
})

